// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { paginationStyles } from "@guestsupply/Overrides/Widgets/ProductList/ProductListPagination";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

paginationStyles.pagination = {
    selectProps: {
        cssOverrides: {
            formInputWrapper: css`
                width: 56px;
                &&&& > select {
                    padding-right: 22px;
                    padding-left: 5px;
                    text-align: center;
                }

                &&&& > span {
                    padding-right: 7px;
                }
            `,
        },
        labelProps: {
            css: css`
                width: auto;
                padding-right: 8px;
                padding-top: 0;
                ${xScreen("lte", "md")} {
                    padding: 0;
                }
                ${xScreen("gt", "md")} {
                    font-size: 14px;
                    font-weight: 400;
                }
            `,
        },
    },
    cssOverrides: {
        perPageSelect: css`
            width: auto;
            ${xScreen("lte", "md")} {
                &.perPageSelect {
                    width: 100%;
                    [class^="FormInputWrapper"] {
                        height: 36px;
                        width: 100%;
                    }
                    [class^="FormFieldStyle"] {
                        ${xScreen("lte", "md")} {
                            flex-direction: column;
                            align-items: baseline;
                            gap: 8px;
                            padding-right: 16px;
                        }
                    }
                    &&& {
                        select.resultsPerPage {
                            height: 36px;
                            text-align: start;
                            padding-left: 9px;
                        }
                    }
                    ${IconWrapper} {
                        top: 6px;
                    }
                }
            }
        `,
        pagination: css`
            margin: 0;
        `,
        linkList: css`
            ${xScreen("lte", "md")} {
                width: auto;
            }
        `,
    },
};
